import React from 'react';

import { Navigate } from 'react-router-dom';

import { useDemoContext } from '@/hooks/DemoContext';
import { useAuth } from '@/hooks/useAuth';

import type { JSX } from 'react';

interface PublicRouteProps {
  children: JSX.Element;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const { isDemo } = useDemoContext();

  if (user || isDemo) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
